/** Client for the review capacity API (task 4170.4). */
import { apiFetch } from "../../app/api";

export interface ClassLoad {
  priority_class: string;
  open_cases: number;
  minutes_per_case: number;
  basis: "observed" | "assumed";
  history_cases: number;
  projected_hours: number;
}

export interface Scenario {
  reviewers: number;
  hours_per_day: number;
  working_days: number;
  completion_date: string;
}

export interface CapacityReport {
  classes: ClassLoad[];
  open_cases: number;
  projected_hours: number;
  queue_open_cases: number;
  reconciled: boolean;
  start_date: string;
  scenarios: Scenario[];
}

export interface CapacityQuery {
  engagement: string;
  run: string;
  reviewers: number[];
  hoursPerDay: number;
}

export function capacityPath(query: CapacityQuery): string {
  const params = new URLSearchParams({
    engagement_id: query.engagement,
    hours_per_day: String(query.hoursPerDay),
  });
  if (query.run) {
    params.set("run_id", query.run);
  }
  for (const count of query.reviewers) {
    params.append("reviewers", String(count));
  }
  return `/api/v1/capacity/review?${params.toString()}`;
}

export function getCapacity(query: CapacityQuery): Promise<CapacityReport> {
  return apiFetch<CapacityReport>(capacityPath(query));
}

/** Reviewer counts from text such as "1, 2, 4". Anything not a positive whole number is dropped. */
export function parseReviewers(text: string): number[] {
  return text
    .split(",")
    .map((part) => Number(part.trim()))
    .filter((count) => Number.isInteger(count) && count > 0);
}
